export default "__VITE_ASSET__CPqNMsOs__"